window.pages.home = {
    init: function () {
    $(function () {

        $('body').addClass('fixed-header');
        $(".page-home .slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            autoplay: true,
            autoplaySpeed: 7000,
            prevArrow: `<div class="left-arrow"><img src="/img/home/arrow_left.png" /></div>`,
            nextArrow: `<div class="right-arrow"><img src="/img/home/arrow_right.png" /></div>`,
        });

        $('.video-play').click(function () {
            $('.full-video-player iframe').attr('src', $(this).data('link'));

            $('.full-video-player').addClass('active');
        });

        $('.full-video-player .full-header button').click(() => {
            $('.full-video-player').removeClass('active');
        });


        $(".page-home .shield-slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            autoplay: true,
            autoplaySpeed: 7000,
            prevArrow: `<button class="left-arrow"><span class="material-icons-outlined">chevron_left</span></button>`,
            nextArrow: `<button class="right-arrow"><span class="material-icons-outlined">chevron_right</span></button>`,
        });

        $(".page-home .shield-slider").on('beforeChange', function (event, slick, currentSlide, nextSlide) {

            $(".page-home .shield-slider-nav li").eq(nextSlide).addClass('active').siblings('li')
                .removeClass('active');
        });

        $('.shield-slider-nav li').click(function () {
            $(this).addClass('active').siblings('li').removeClass('active');

            $(".page-home .shield-slider").slick('slickGoTo', $(this).data('slide'));
        });
        $(".page-home .video-slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            centerMode: true,
            centerPadding: 180,
            variableWidth: true,
            dots: true,
            fade: false,
            focusOnSelect: true,
            autoplay: true,
            autoplaySpeed: 7000,
            prevArrow: `<button class="left-arrow"><img src="/img/home/arrow_left_red.png" /></button>`,
            nextArrow: `<button class="right-arrow"><img src="/img/home/arrow_right_red.png" /></button>`,
        });
    });
    },
};



